<template>
  <div v-if="hasPages" class="d-flex">
    <ul class="list-unstyled d-flex flex-row mx-auto flex-wrap pagination">
      <li :class="hasPrev ? 'prev' : 'prev disabled'">
        <span @click.prevent="hasPrev ? changePage(prevPage) : null"></span>
      </li>
      <li :class="pageClass(-1)" v-if="hasFirst">
        <span @click.stop="changePage(1)">1</span>
      </li>
      <li class="ellipsis" v-if="hasFirst">..</li>
      <li v-for="page in pages" :class="pageClass(page)">
        <span @click.stop="changePage(page)">{{ page }}</span>
      </li>
      <li class="ellipsis" v-if="hasLast">..</li>
      <li :class="pageClass(-1)" v-if="hasLast">
        <span @click.stop="changePage(totalPages)">{{ totalPages }}</span>
      </li>
      <li :class="hasNext ? 'next' : 'next disabled'">
        <span @click.prevent="hasNext ? changePage(nextPage) : null"></span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    current: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    perpage: {
      type: Number,
      default: 9,
    },
    pagerange: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    pages: function() {
      const pages = [];
      for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
        pages.push(i);
      }
      return pages;
    },
    hasPrev: function() {
      return this.current > 1;
    },
    hasNext: function() {
      return this.current < this.totalPages;
    },
    hasFirst: function() {
      return this.rangeStart !== 1;
    },
    hasLast: function() {
      return this.rangeEnd < this.totalPages;
    },
    totalPages: function() {
      return Math.ceil(this.total / this.perpage);
    },
    prevPage: function() {
      return this.current - 1;
    },
    nextPage: function() {
      return this.current + 1;
    },
    rangeStart: function() {
      const start = this.current - this.pagerange;
      return ((start > 0) && this.pagerange > 0) ? start : 1;
    },
    rangeEnd: function() {
      const end = this.current + this.pagerange;
      return ((end < this.totalPages) && this.pagerange > 0) ? end : this.totalPages;
    },
    hasPages: function() {
      return this.totalPages > 0;
    },
  },
  methods: {
    changePage: function(page) {
      if (page > 0 && page <= this.totalPages) {
        this.$emit('page-changed', page);
      }
    },
    pageClass: function(page) {
      let classes = [];
      if (page == this.current) {
        classes.push('current');
      }
      return classes.join(' ');
    },
  },
};
</script>
<style scoped>
li {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

li span {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
}

li.ellipsis {
  width: 12px;
  margin-left: -6px;
  margin-right: -6px;
  text-align: center;
}

li.prev span:after {
  content: '';
  display: block;
  border-top: 6px solid transparent !important;
  border-right: 8px solid black;
  border-bottom: 6px solid transparent !important;
  border-left: none;
  margin-right: 3px;
  margin-top: 2px;
}

li.next span:after {
  content: '';
  display: block;
  border-top: 6px solid transparent !important;
  border-right: none;
  border-bottom: 6px solid transparent !important;
  border-left: 8px solid black;
  margin-left: 3px;
  margin-top: 2px;
}
</style>
